<template>
  <div class="menu-panel-root">
    <div class="menu-panel">

      <div class="menu-section" v-if="showSalesSection">
        <div class="section-title">
          <!-- <span class="section-icon">💰</span> -->
          <!-- <img class="section-img" src="../assets/usd.png" > -->
          <!-- <span>Sales</span> -->
        </div>
        <div class="section-grid">
          <router-link v-if="hasPermission(1)" class="menu-card" :to="{ name: 'main' }">
            <div class="card-icon-wrapper">
              <!-- <span class="card-icon-emoji"><i class="fi fi-rr-shopping-cart"></i></span> -->
              <img class="card-icon" :src="shopping" alt="POS">

            </div>
            <span class="card-label">{{ jsonData.pos || 'POS' }}</span>
          </router-link>

          <router-link v-if="hasPermission(26)" class="menu-card" :to="{ name: 'find' }">
            <div class="card-icon-wrapper">
              <!-- <span class="card-icon-emoji">🔍</span> -->
              <img class="card-icon" :src="searchIcon" alt="Find">
            </div>
            <span class="card-label">{{ jsonData.find_invoice || 'Find Invoice' }}</span>
          </router-link>

          <router-link v-if="hasPermission(31)" class="menu-card" :to="{ name: 'prod_return' }">
            <div class="card-icon-wrapper">
              <!-- <span class="card-icon-emoji">↩️</span> -->
              <img class="card-icon" :src="undoIcon" alt="Return">

            </div>
            <span class="card-label">{{ jsonData.return_invoice || 'Return Invoice' }}</span>
          </router-link>

          <router-link v-if="hasPermission(56)" class="menu-card" :to="{ name: 'sync_ura' }">
            <div class="card-icon-wrapper">
              <!-- <span class="card-icon-emoji">🔄</span> -->
              <img class="card-icon" :src="restock" alt="Sync">

            </div>
            <span class="card-label">{{ jsonData.unsynced_invoices || 'UnSynced Sales' }}</span>
          </router-link>

          <router-link v-if="hasPermission(20)" class="menu-card" :to="{ name: 'customers' }">
            <div class="card-icon-wrapper">
              <!-- <span class="card-icon-emoji">👥</span> -->
              <img class="card-icon" :src="cust" alt="Customers">

            </div>
            <span class="card-label">{{ jsonData.customers || 'Customers' }}</span>
          </router-link>

          <router-link v-if="hasPermission(67)" class="menu-card" :to="{ name: 'giftcards' }">
            <div class="card-icon-wrapper">
              <!-- <span class="card-icon-emoji">🎁</span> -->
              <img class="card-icon" :src="gift" alt="Gift Cards">

            </div>
            <span class="card-label">{{ jsonData.giftcards || 'Gift Cards' }}</span>
          </router-link>

                    <router-link v-if="hasPermission(47)" class="menu-card" :to="{ name: 'products' }">
            <div class="card-icon-wrapper">
              <!-- <span class="card-icon-emoji">🏷️</span> -->
              <img class="card-icon" :src="tag" alt="Products">

            </div>
            <span class="card-label">{{ jsonData.products || 'Products' }}</span>
          </router-link>

          <router-link v-if="hasPermission(65)" class="menu-card" :to="{ name: 'product_management' }">
            <div class="card-icon-wrapper">
              <!-- <span class="card-icon-emoji">🗂️</span> -->
              <img class="card-icon" :src="folderGear" alt="Management">
            </div>
            <span class="card-label">{{ jsonData.product_management || 'Management' }}</span>
          </router-link>

          <router-link v-if="hasPermission(41)" class="menu-card" :to="{ name: 'promotions' }">
            <div class="card-icon-wrapper">
              <!-- <span class="card-icon-emoji">🎁</span> -->
              <img class="card-icon" :src="kIcon" alt="Promotions">
            </div>
            <span class="card-label">{{ jsonData.promotions || 'Promotions' }}</span>
          </router-link>

          <router-link v-if="hasPermission(15)" class="menu-card" :to="{ name: 'main', query: { action: 'parked' } }">
            <div class="card-icon-wrapper">
              <!-- <span class="card-icon-emoji">⏸️</span> -->
              <img class="card-icon" :src="stopIcon" alt="Parked">
            </div>
            <span class="card-label">{{ jsonData.menu_parked || 'Parked' }}</span>
          </router-link>

          <router-link v-if="hasPermission(44)" class="menu-card" :to="{ name: 'users' }">
            <div class="card-icon-wrapper">
              <!-- <span class="card-icon-emoji">👤</span> -->
              <img class="card-icon" :src="userIcon" alt="Users">
            </div>
            <span class="card-label">{{ jsonData.users || 'Users' }}</span>
          </router-link>

                    <router-link v-if="hasPermission(68)" class="menu-card" :to="{ name: 'shifts' }">
            <div class="card-icon-wrapper">
              <!-- <span class="card-icon-emoji">⏱️</span> -->
              <img class="card-icon" :src="cIcon" alt="Shifts">
            </div>
            <span class="card-label">{{ jsonData.shifts || 'Shifts' }}</span>
          </router-link>

          <router-link v-if="hasPermission(71)" class="menu-card" :to="{ name: 'general_settings' }">
            <div class="card-icon-wrapper">
              <!-- <span class="card-icon-emoji">⚙️</span> -->
              <img class="card-icon" :src="gearsIcon" alt="Settings">
            </div>
            <span class="card-label">{{ jsonData.settings || 'Settings' }}</span>
          </router-link>

          <router-link v-if="hasPermission(48)" class="menu-card" :to="{ name: 'machines' }">
            <div class="card-icon-wrapper">
              <!-- <span class="card-icon-emoji">🖥️</span> -->
              <img class="card-icon" :src="laptopIcon" alt="Machines">

            </div>
            <span class="card-label">{{ jsonData.machines || 'Machines' }}</span>
          </router-link>

          <router-link v-if="hasPermission(53)" class="menu-card" :to="{ name: 'mobile_payment_proivder' }">
            <div class="card-icon-wrapper">
              <!-- <span class="card-icon-emoji">📱</span> -->
               <img :src="mobileIcon" class="card-icon" alt="Mobile Payment">
            </div>
            <span class="card-label">{{ jsonData.mobile_payment_provider || 'Mobile Payment' }}</span>
          </router-link>

          <button v-if="hasPermission(45)" class="menu-card" @click="handleCloseCash">
            <div class="card-icon-wrapper">
              <!-- <span class="card-icon-emoji">🎁</span> -->
              <img class="card-icon" :src="img">

            </div>
            <span class="card-label">{{ jsonData.close_cash_btn }}</span>
          </button>

          <button v-if="hasPermission(14)" class="menu-card" @click="handleChangePassword">
            <div class="card-icon-wrapper">
              <!-- <span class="card-icon-emoji">🎁</span> -->
              <img class="card-icon" :src="img2">

            </div>
            <span class="card-label">{{ jsonData.change_password || 'Change Password' }}</span>
          </button>

          <router-link v-if="hasPermission(32)" class="menu-card" :to="{ name: 'reports' }">
            <div class="card-icon-wrapper">
              <!-- <span class="card-icon-emoji">📊</span> -->
              <img class="card-icon" :src="nIcon" alt="Reports">
            </div>
            <span class="card-label">{{ jsonData.reports || 'Reports' }}</span>
          </router-link>

            <!-- <button v-if="hasPermission(71)" class="menu-card" @click="handleColorSettings">
            <div class="card-icon-wrapper">
              <img class="card-icon" :src="gearsIcon" alt="Settings">
            </div>
            <span class="card-label">Colors Settings</span>
          </button> -->
        </div>
      </div>
    </div>
  </div>
  <CloseCash
    :open="isCloseCashOpen"
    @close="isCloseCashOpen = !isCloseCashOpen"
    @setCashDetail="closeUserCash($event)"
    ref="CloseCashref"
  />
    <ChangePassword
    :open="isChangePasswordOpen"
    @close="isChangePasswordOpen = !isChangePasswordOpen"
  />
</template>

<script>
import commonServices from "@/shared/commonServices";
import axios from "axios";
import CloseCash from "@/components/CloseCash";
import ChangePassword from "@/components/ChangePassword";
import shopping from '@/assets/12.png'
import searchIcon from '@/assets/13.png'
import undoIcon from '@/assets/14.png'
import restock from '@/assets/19.png'
import cust from '@/assets/16.png'
import gift from '@/assets/22.png'
import img from '@/assets/28.png'
import img1 from '@/assets/29.png'
import img2 from '@/assets/30.png'
import tag from '@/assets/18.png'
import folderGear from '@/assets/17.png'
import kIcon from '@/assets/15.png'
import stopIcon from '@/assets/20.png'
import userIcon from '@/assets/23.png'
import cIcon from '@/assets/21.png'
import gearsIcon from '@/assets/24.png'
import laptopIcon from '@/assets/25.png'
import nIcon from '@/assets/26.png'
import mobileIcon from '@/assets/27.png'

export default {
  name: "MenuDropdown",
  mixins: [commonServices],
  components: { CloseCash, ChangePassword },
  data() {
    return {
      jsonData: {},
      shopping,
      searchIcon,
      undoIcon,
      restock,
      cust,
      gift,
      img,
      img1,
      img2,
      tag,
      folderGear,
      kIcon,
      stopIcon,
      userIcon,
      cIcon,
      gearsIcon,
      laptopIcon,
      nIcon,
      mobileIcon,
      isCloseCashOpen: false,
      isChangePasswordOpen: false,
      paymentData: [],
      mobilePaymentProviderJson: {},
    };
  },

  mounted() {
    try {
      if (!localStorage.language || localStorage.language === "en") {
        this.jsonData = require("../../public/assets/en.json");
      } else {
        this.jsonData = require("../../public/assets/ar.json");
      }
    } catch (err) {
      this.jsonData = {};
    }
    const action = this.$route.query.action;
    if (action === "parked") {
      this.getShowParked();
    } else if (action === "change_password") {
      this.isChangePasswordOpen = true;
    }
    
  },
  methods: {
    handleMainPage() {
      this.$router?.push({ name: "main" });
    },
    handleChangePassword() {
      this.isChangePasswordOpen = true;
     // this.$router?.push({ name: "main", query: { action: "change_password" } });
    },
    handleFindInvoice() {
      this.$router?.push({ name: "find" });
    },
    handleAddCustomer() {
      this.$router?.push({ name: "customers" });
    },
    getShowParked() {
      this.$router?.push({ name: "parked" });
    },
    getpaymentnoncash: async function () {
      let userId = localStorage.userId;
      this.mobilePaymentProviderJson.userId = userId;
      try {
        let dataURL = this.apiURL + "Orders/get_payment_info";
        let response = await axios.post(
          dataURL,
          this.mobilePaymentProviderJson
        );
        if (response.data.status === "success") {
          this.paymentData = response.data.results;
          this.$refs.CloseCashref.getpaymentnoncash(this.paymentData);
        }
      } catch (error) {
        console.log(error);
      }
      return this.paymentData;
    },
    handleColorSettings() {
      this.$router?.push({ name: 'theme_settings' });
    },
    handleCloseCash: async function () {
      this.getpaymentnoncash();

      this.isCloseCashOpen = true;
    },
    printElemm: function (elem) {
      var mywindow = window.open(
        "",
        "PRINT",
        "toolbar=no,status=no,menubar=no,scrollbars=no,resizable=no,left=0, top=0, width=10, height=10, visible=none"
      );
      mywindow.document.write(
        '<html><head><title> Invoice </title><style>* {font-size: 12px;font-family: "Times New Romantd, th, tr, table { border-top: 1px solid black; border-collapse: collapse; } "; } td.description, th.description { width: 75px; max-width: 75px; } td.quantity, th.quantity { width: 40px; max-width: 40px; word-break: break-all; } td.price, th.price { width: 40px; max-width: 40px; word-break: break-all; } .centered { text-align: center; align-content: center; } .ticket { width: 155px; max-width: 155px; }</style>'
      );
      mywindow.document.write("</head><body>");
      mywindow.document.write(elem);
      mywindow.document.write("<br><br></body></html>");
      mywindow.print();
      mywindow.close();
      return true;
    },
    closeUserCash: async function (cashDetail) {
      try {
        const nowDate = new Date();
        let dataURL = this.apiURL + "GiftCard/closeDailyShift1";
        let closeUserCashJson = {
          appId: "7",
          userId: localStorage.userId,
          orderDate: this.dateToYMD(nowDate),
        };
        let response = axios
          .post(dataURL, closeUserCashJson)
          .then((res) => {})
          .catch((error) => {
            console.log(error);
          });
        this.printCashDetail(cashDetail);
      } catch (error) {
        console.log(error);
      }
    },
    printCashDetail(cashDetail) {
      let totalAmount = 0;
      let cashDetailVal = [];
      cashDetailVal = cashDetail;
      const nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth() + 1;
      let day = nowDate.getDate();
      var today = new Date();
      var time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      var cashier = localStorage.username;
      let viaInvStr = "";
      let totalCash = 0;
      viaInvStr = viaInvStr + "<p>FRAINE SUPERMARKET<br/>Cashier Closing</p>";
      viaInvStr =
        viaInvStr +
        "<tr><td> Date : " +
        day +
        "/" +
        month +
        "/" +
        year +
        " " +
        time +
        "<br></td></tr>";
      viaInvStr =
        viaInvStr + "<tr><td> Cashier : " + cashier + "<br></td></tr>";
      viaInvStr =
        viaInvStr + '<table align="center" width="100%"><tr bgcolor="#EEE">';
      viaInvStr =
        viaInvStr + '<td colspan=3 align="center"><b>CURRENCY TYPES</b></td>';
      viaInvStr =
        viaInvStr + '<td width="33%" align="center"><b>COUNT</b></td>';
      viaInvStr =
        viaInvStr + '<td width="33%" align="center"><b>VALUE</b></td>';
      viaInvStr = viaInvStr + "</tr>";
      cashDetailVal.forEach(function (cashDetailItem) {
        viaInvStr =
          viaInvStr +
          '<tr><td colspan=3 align="left">' +
          cashDetailItem.value +
          '</td><td width="33%" align="center">' +
          cashDetailItem.count +
          '</td><td width="33%" align="center">' +
          cashDetailItem.value +
          "</td></tr>";
        if (!isNaN(cashDetailItem.value)) {
          totalAmount +=
            parseInt(cashDetailItem.value) * parseInt(cashDetailItem.count);
        } else {
          totalAmount += parseInt(cashDetailItem.count);
        }
      });
      viaInvStr =
        viaInvStr +
        '<tr bgcolor="#EEE"><td width="50%" align="left" colspan=2><b>TOTAL:</b></td><td width="50%" align="right" colspan=3><b>' +
        totalAmount +
        "</b></td></tr>";
      this.printElemm(viaInvStr);
      localStorage.clear();
      this.$router.push({ name: "login" });
    },
  },
  computed: {
    showSalesSection() {
      return [1, 26, 31, 56, 15, 14].some((p) => this.hasPermission(p));
    },
    showPeopleSection() {
      return [20, 44, 67].some((p) => this.hasPermission(p));
    },
    showProductsSection() {
      return [47, 65, 41, 15].some((p) => this.hasPermission(p));
    },
    showCashSection() {
      return [45, 63, 53, 32].some((p) => this.hasPermission(p));
    },
    showOthersSection() {
      return [68, 32, 71, 48].some((p) => this.hasPermission(p));
    },
  },
};
</script>

<style scoped>
.menu-panel-root {
  min-height: calc(100vh - 120px);
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

/* .menu-panel {
  background: linear-gradient(135deg, #1e2332 0%, #252d42 100%);
  color: white;
  border-radius: 24px;
  padding: 2rem;
  width: 100%;
  max-width: 1200px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(92, 107, 192, 0.2);
  animation: fadeInUp 0.6s ease-out;
} */

.menu-panel {
  background: var(--theme-bg-start);
  color: white;
  border-radius: 24px;
  padding: 2rem;
  width: 100%;
  max-width: 1200px;
  box-shadow: 0 20px 60px #00000066;
  border: 1px dashed #5c6bc040;

  backdrop-filter: blur(1px);
  -webkit-backdrop-filter: blur(1px);

  animation: fadeInUp 0.6s ease-out;
}


@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.menu-section {
  margin-bottom: 2.5rem;
  animation: fadeIn 0.8s ease-out;
}

.menu-section:last-child {
  margin-bottom: 0;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.section-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-weight: 700;
  margin-bottom: 1.25rem;
  font-size: 1.5rem;
  color: #ffffff;
  padding-bottom: 0.75rem;
  /* border-bottom: 2px solid rgba(92, 107, 192, 0.3); */
}

.section-icon {
  font-size: 1.75rem;
  filter: drop-shadow(0 2px 4px #0000004d);
}

.section-img {
  width: 26px;
  height: 26px;
  object-fit: contain;
  display: block;
  max-width: 100%;
  max-height: 100%;
}
.section-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
}

.menu-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.875rem;
  padding: 1.75rem 1rem;
  /* background: linear-gradient(135deg, #5c6bc0 0%, #4a5ab5 100%); */
  border: 2px dashed #ffffff1a;
  border-radius: 20px;
  color: white;
  cursor: pointer;
  text-align: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  min-height: 160px;
  flex: 1 1 160px;
  max-width: 200px;
  width: 100%;
  text-decoration: none;
}

.menu-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #ffffff1a 0%, #ffffff00 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.menu-card:hover::before {
  opacity: 1;
}

.menu-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 20px var(--theme-primary) 0%;
  border-color: #ffffff4d;
  background: linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-secondary) 100%);
  border: 2px dashed var(--theme-secondary);
}

.menu-card:active {
  transform: translateY(-4px) scale(0.98);
}

.card-icon-wrapper {
  width: 72px;
  height: 72px;
  /* background: rgba(255, 255, 255, 0.15); */
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  /* backdrop-filter: blur(10px); */
  /* border: 2px solid rgba(255, 255, 255, 0.2); */
}

/* .menu-card:hover .card-icon-wrapper {

  transform: scale(1.1) rotate(5deg);
  background: rgba(255, 255, 255, 0.25);
} */

.card-icon-emoji {
  font-size: 2.5rem;
  line-height: 1;
}

.card-icon {
  width: 60px;
  height: 60px;
  object-fit: contain;
  display: block;
  max-width: 100%;
  max-height: 100%;
}

.card-label {
  font-size: 1.8rem;
  font-weight: 600;
  line-height: 1.;
  max-width: 100%;
  word-wrap: break-word;
  color: #fffffff2;
}

@media (max-width: 1200px) {
  .section-grid {
    gap: 1rem;
  }
  .menu-card {
    flex-basis: 145px;
  }
}

@media (max-width: 768px) {
  .menu-panel {
    padding: 1.5rem;
    border-radius: 20px;
  }

  .section-title {
    font-size: 1.25rem;
    margin-bottom: 1rem;
  }

  .section-icon {
    font-size: 1.5rem;
  }

  .section-grid {
    gap: 0.875rem;
  }
  
  .menu-card {
    flex-basis: 130px;
  }

  .menu-card {
    padding: 1.5rem 0.875rem;
    border-radius: 16px;
    min-height: 140px;
  }


  .card-icon-wrapper {
    width: 64px;
    height: 64px;
  }

  .card-icon {
    width: 40px;
    height: 40px;
  }

  .card-icon-emoji {
    font-size: 2.25rem;
  }

  .card-label {
    font-size: 0.9375rem;
  }
}

@media (max-width: 480px) {
  .menu-panel-root {
    padding: 0.5rem;
  }

  .menu-panel {
    padding: 1.25rem;
    border-radius: 16px;
  }

  .section-title {
    font-size: 1.125rem;
  }

  .section-grid {
    gap: 0.75rem;
  }
  .menu-card {
    flex-basis: 100px;
  }

  .menu-card {
    padding: 1.25rem 0.75rem;
    min-height: 130px;
  }

  .card-icon-wrapper {
    width: 56px;
    height: 56px;
  }

  .card-icon {
    width: 36px;
    height: 36px;
  }

  .card-icon-emoji {
    font-size: 2rem;
  }

  .card-label {
    font-size: 0.875rem;
  }

  .menu-section {
    margin-bottom: 2rem;
  }
}

@media (max-width: 360px) {
  .menu-card {
    flex-basis: calc(50% - 1rem);
  }
}
</style>
